import { FC } from 'react'
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'

import type { Menu } from "../../../types/menuTypes";

type SimpleLanguageSelectorProps = {
  menu?: Menu
  currentLanguage?: {
    currentLang: string | undefined
    setCurrentLang: (lang: string) => void
  }
}

const SimpleLanguageSelector: FC<SimpleLanguageSelectorProps> = ({
  menu,
  currentLanguage
})  => {
  if (!menu || !currentLanguage) return
  return (
    <Listbox value={currentLanguage.currentLang} onChange={currentLanguage.setCurrentLang}>
      <div className="relative">
        <ListboxButton className="bg-white dark:bg-gray-900 grid w-full cursor-default grid-cols-1 rounded-md py-1.5 pr-3 pl-3 text-left text-gray-900 dark:text-white/90 border border-gray-200 dark:border-gray-800 focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-indigo-500 sm:text-sm/6">
          <span className="col-start-1 row-start-1 flex items-center gap-3">
            <img
              alt=""
              src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${currentLanguage?.currentLang?.toUpperCase()}.svg`}
              className="size-8"
            />
            <span className="block truncate">{currentLanguage.currentLang}</span>
          </span>
        </ListboxButton>

        <ListboxOptions
          transition
          className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-gray-100 dark:bg-gray-800 text-base border border-gray-200 dark:border-gray-800 data-leave:transition data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm"
        >
          {menu?.languages.map((l) => (
            <ListboxOption
              key={`language-${l.language}`}
              value={l.language}
              className="group relative cursor-default py-2 pl-3 text-gray-900 dark:text-white/90 select-none data-focus:bg-indigo-500 data-focus:outline-hidden"
            >
              <div className="flex items-center">
                <img
                  alt=""
                  src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${l.language.toUpperCase()}.svg`}
                  className="size-8"
                />
                <span className="ml-3 block truncate font-normal group-data-selected:font-semibold">{l.language}</span>
              </div>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  )
}

export default SimpleLanguageSelector
